import { createPath } from "@/service/routing/routing";

export const historyAndFavouriteSections = {
  tutorial: {
    createItemPath: ({ category, slug }) =>
      createPath("tutorial.show", {
        category: category.slug,
        tutorial: slug,
      }),
    historyLink: createPath("tutorial.history"),
    favouriteLink: createPath("tutorial.favourite"),
  },
  fast_question: {
    createItemPath: ({ category, slug }) =>
      createPath("fast_question.show", {
        category: category.slug,
        tutorial: slug,
      }),
    historyLink: createPath("fast_question.history"),
    favouriteLink: createPath("fast_question.favourite"),
  },
  calculator: {
    createItemPath: ({ category, slug }) =>
      createPath("calculator.show", {
        categorySlug: category.slug,
        slug: slug,
      }),
    historyLink: createPath("calculator.history"),
    favouriteLink: createPath("calculator.favourite"),
  },
  meds: {
    createItemPath: ({ id, slug }) =>
      createPath("meds.group.show", {
        slug,
        id,
      }),
    historyLink: createPath("meds.history"),
    favouriteLink: createPath("meds.favourite"),
  },
  icd10: {
    createItemPath: ({ category, slug }) =>
      createPath("icd10.slug", {
        categorySlug: category.slug,
        codeSlug: slug,
      }),
    historyLink: createPath("icd10.history"),
    favouriteLink: null,
  },
  medical_supply: {
    createItemPath: ({ slug }) =>
      createPath("medical-supplies.show", {
        slug,
      }),
    historyLink: createPath("medical-supplies.history"),
    favouriteLink: createPath("medical-supplies.favourite"),
  },
  article: {
    createItemPath: ({ category, slug, isVademecum }) =>
      createPath(isVademecum ? "vademecum.show" : "publication.show", {
        categorySlug: category.slug,
        slug: slug,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  clinical_case: {
    createItemPath: ({ category, slug }) =>
      createPath("clinical_case.show", {
        categorySlug: category.slug,
        slug,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  course: {
    createItemPath: ({ slug, id }) =>
      createPath("course.show", {
        slug,
        id,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  ebook: {
    createItemPath: ({ slug }) =>
      createPath("ebook.show", {
        slug,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  residency_specialization: {
    createItemPath: ({ slug }) =>
      createPath("residency_encyclopedia.show", {
        slug,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  video: {
    createItemPath: ({ slug, id }) =>
      createPath("video.show", {
        slug,
        id,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  playlist: {
    createItemPath: ({ slug, id }) =>
      createPath("video.show", {
        slug,
        id,
      }),
    historyLink: null,
    favouriteLink: null,
  },
  playlist_episode: {
    createItemPath: ({ slug, id, playlist }) =>
      createPath("video.playlist.show", {
        slug: playlist.slug,
        id: playlist.id,
        videoSlug: slug,
        videoId: id,
      }),
    historyLink: null,
    favouriteLink: null,
  },
} as const;
